import Vue from 'vue'
import Vuex from 'vuex'

import autenticacao from './autenticacao'
import cadastro from './cadastro'
import detalheCadastro from './detalheCadastro'
import empresa from './empresa'
import item from './item'
import agendamento from './agendamento'
import notificacaoTabs from './notificacaoTabs'
import report from './relatorios'
import pedido from './pedido'
import shared from './shared'
import toastr from './toastr'

import cantAccess from './cantAccess'
import Checkin from './Checkin'
import Checkout from './Checkout'
import feedback from './hotsite/feedback'
import confirmacao from './hotsite/confirmacao'

Vue.use(Vuex)

export const store = new Vuex.Store({
  modules: {
    shared,
    autenticacao,
    agendamento,
    cadastro,
    detalheCadastro,
    empresa,
    feedback,
    confirmacao,
    item,
    notificacaoTabs,
    report,
    pedido,
    toastr,
    cantAccess,
    Checkin,
    Checkout
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js